import { render, staticRenderFns } from "./PerformerForm.vue?vue&type=template&id=44bac034&scoped=true"
import script from "./PerformerForm.vue?vue&type=script&lang=js"
export * from "./PerformerForm.vue?vue&type=script&lang=js"
import style0 from "./PerformerForm.vue?vue&type=style&index=0&id=44bac034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bac034",
  null
  
)

export default component.exports